import React from 'react';
import { Divider, Text } from '@chakra-ui/react';
import PropType from 'prop-types';

function TabPanelHeader({ title }) {
  return (
    <>
      <Text
        p={5}
        textAlign="left"
        textStyle="bodyXl500"
      >
        {title}
      </Text>
      <Divider />
    </>
  );
}

TabPanelHeader.propTypes = {
  title: PropType.string
};

export default TabPanelHeader;
